import { cn } from "~/lib/cn";

type SocialNetwork = "instagram" | "youtube" | "linkedin";

/**
 * T872 S1 — the three social glyphs, 20×20 inside a 44×44 target, `currentColor`.
 * Instagram and YouTube keep the outlined drawing the footer already had; LinkedIn
 * is the filled «in» silhouette from the design pass
 * (`design_handoff_tfc/assets/linkedin-monochrome.svg`), which the earlier stroke
 * drawing failed to make recognisable.
 */
function Glyph({ network }: { network: SocialNetwork }) {
  if (network === "instagram") {
    return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
      </svg>
    );
  }
  if (network === "youtube") {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="2.5" y="5.5" width="19" height="13" rx="4" />
        <path d="M10.5 9.5l5 2.5-5 2.5z" fill="currentColor" stroke="none" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.049c.476-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM7.119 20.452H3.555V9h3.564v11.452z" />
    </svg>
  );
}

interface SocialLinkProps {
  network: SocialNetwork;
  href: string;
  /** Accessible name — the network's name; the surface adds "(opens in a new tab)" if it wants to. */
  label: string;
  className?: string;
}

/** One social link, the same component wherever the networks appear (footer today). */
export function SocialLink({ network, href, label, className }: SocialLinkProps) {
  return (
    <a
      className={cn("foot-social", className)}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
    >
      <Glyph network={network} />
    </a>
  );
}
